export default __webpack_public_path__ + "static/media/classFlow.6b354ab0.svg";